import _ from 'lodash';
// import { combineReducers } from 'redux';


import {
  MESSAGE_CAPTURE,
  MESSAGE_RESET,
} from '../actions/messageFormAction';

/**
 * Function containing reducers for messageForm.
 *
 * @param {Object} initialState Initial state for this component.
 * @param {Object} action Action to be dispatched.
 * @returns {Object} New state to be stored.
 */
export default (initialState = { text : {} }, action) => {
  switch (action.type) {
    case MESSAGE_CAPTURE: {
      // Capture user message for a given thread.
      // Messages are indexed by threadId.
      return {
        ...initialState,
        text: { ...initialState.text, [action.threadId]: action.payload }
      };
    }

    case MESSAGE_RESET: {
      // Reset user message for a given thread.
      // Messages are indexed by threadId.
      return {
        ...initialState,
        text: _.pickBy(
          initialState.text,
          (text, threadId) => threadId != action.threadId
        ) };
    }

    default:
      return initialState;
  }

};



// WEBPACK FOOTER //
// ./src/redux/reducers/messageFormReducer.jsx